import { IKpiMetrics, IKpiTimeResponse, IKpiResponse, IKpiTiresResponse, IKpiTiresDto } from './indicator-dto';

export interface IIndicatorDto {
  kpiTiresHistory: IKpiTiresDto[];
  kpiTires: IKpiTiresDto[];
  kpiTiresResponse: IKpiTiresResponse;
  kpiPerVehicleAndPlate: IKpiMetrics[];
  kpiPerTime: IKpiTimeResponse;
  kpiPerVehicleAndStatistics: IKpiResponse;
}

export const defaultValue: Readonly<IIndicatorDto> = {
  kpiTiresHistory: [],
  kpiTires: [],
  kpiTiresResponse: {
    grooveAlerts: [],
    pressureAndTemperatureAlerts: [],
    retreadedTires: [],
    average: 0,
    percentage: 0,
    avgInStockInstalled: 0,
    averageWaste: 0,
    odometerInstalled: null,
    odometerStock: null,
    odometerWaste: null,
  },
  kpiPerVehicleAndPlate: [],
  kpiPerTime: {
    valuesToChart: [],
    statistics: {
      maxValue: 0,
      minValue: 0,
      avgValue: 0,
    },
    averageFleet: 0,
    averageVehicle: 0,
  },
  kpiPerVehicleAndStatistics: {
    values: [],
    valuesToChart: [],
    statistics: {
      maxValue: 0,
      minValue: 0,
      totalValue: 0,
      totalVehicles: 0,
    },
  },
};
